import React from 'react'
import { OliveImages } from '@olive/images'
import { useConfig } from '../../context/ConfigContext';
import { Heading } from '@ds/ui';
import { Image } from '@ds/ui';

export default function BrandHeader() {
  const CDN_Images = OliveImages()
  const dsLogoInverse = CDN_Images.dsLogoInverse

  return (
    <div style={{
      margin: '0 auto',
      width: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>


      {/* Header */}
      <header style={{ 
        backgroundColor: '#2B047F',
        height: '8.1875rem',
        width: '100%',
        flexShrink: 0,
        boxShadow: '0px 1px 0px 0px rgba(25,24,35,0.15)'
      }}>
        <div style={{
          maxWidth: '90rem',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '100%',
          paddingLeft: '7.875rem',
          paddingRight: 0
        }}>
          <h1 style={{
            color: '#FFF',
            fontWeight: 600,
            lineHeight: '125%',
            letterSpacing: 'var(--Font-Letter-Spacing-auto, 0px)',
            margin: 0
          }}>
            Security Appliance
          </h1>
          <div style={{ marginRight: '4.1875rem' }}>
            <Image 
              src={dsLogoInverse}
              alt="DocuSign"
              width={140}
              height={28}
            />
          </div>
        </div>
      </header>
    </div>
  )
}